import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(3),
  },
  groupCountText: {
    width: '50%',
    marginRight: theme.spacing(5),
  },
  clientGroupCountText: {
    color: theme.palette.secondary.main,
  },
  plannerGroupCountText: {
    color: theme.palette.primary.main,
  },
});

const groupToCountSuffix = {
  Client: "To Do's",
  Planner: 'Tasks',
};

const getCountSuffixFromGroup = (group) => {
  return groupToCountSuffix[group] || '';
};

const PredefinedTaskGroupCount = ({
  className,
  classes,
  groupTaskCount,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {['Client', 'Planner'].map((group) => {
        const count = groupTaskCount[group];
        const countText = `${group} ${getCountSuffixFromGroup(group)} (${count})`;
        return (
          <Typography
            variant="h3"
            className={classNames(classes.groupCountText, {
              [classes.clientGroupCountText]: group === 'Client',
              [classes.plannerGroupCountText]: group === 'Planner',
            })}
          >
            {countText}
          </Typography>
        );
      })}
    </div>
  );
};

PredefinedTaskGroupCount.defaultProps = {
  className: '',
};

PredefinedTaskGroupCount.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  groupTaskCount: PropTypes.object.isRequired,
};

export default withStyles(styles)(PredefinedTaskGroupCount);
